import { callApiWithTimeout, getBaseUrl } from '../utils/api.util';
import ApiAbortController from '../utils/ApiAbortController';
import { permissionsMapper } from './permissionsMapper';

function getPermissions() {
  return callPermissionsApi().then(permissions => permissionsMapper(permissions));
}

export const callPermissionsApi = () =>
  callApiWithTimeout(`${getBaseUrl()}/permissions`, {}, '', 5000, true, new ApiAbortController());

export default getPermissions;
